export type TaskListSectionModel = {
  id?: number,
  cache_key?: number,
  checklist_template_id?: number,
  data?: object,
  dates?: {
    due: {
      date: string,
    },
  },
  debtor_id?: number,
  debtor_type?: string,
  due_date?: string,
  footer?: string,
  header?: string,
  hidden?: boolean,
  priority?: string,
  sort?: number,
  task_list_id?: number,
  task_list_template_section_id?: number,
  title?: string,
}

export type TaskListSectionRequestOptions = {}

const state = {
  checklist_template_id: undefined,
  data: {},
  debtor_id: undefined,
  debtor_type: undefined,
  due_date: '',
  footer: '',
  header: '',
  hidden: false,
  id: undefined,
  priority: 'default',
  sort: undefined,
  task_list_id: undefined,
  task_list_template_section_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
